// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'
import Ads from 'vue-google-adsense'
import VueAnalytics from 'vue-analytics'
import Constants from './constants'
import Sprintf from 'sprintf-js'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)
Vue.use(VueI18n)
Vue.use(Sprintf)

Vue.use(VueAnalytics, {
  id: 'UA-107855771-3',
  router
})

Vue.prototype.$version = '1.0.9'
Vue.prototype.$constants = Constants
Vue.prototype.$sprintf = Sprintf

const data = require('./message.json')
const i18n = new VueI18n({
  locale: 'ja',
  messages: data
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js